"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_SHARING_SERVICES_BI_MAP = exports.SOCIAL_SHARING_SERVICES = void 0;
var SOCIAL_SHARING_SERVICES;
(function (SOCIAL_SHARING_SERVICES) {
    SOCIAL_SHARING_SERVICES["FACEBOOK"] = "FACEBOOK";
    SOCIAL_SHARING_SERVICES["TWITTER"] = "TWITTER";
    SOCIAL_SHARING_SERVICES["BLOGGER"] = "BLOGGER";
    SOCIAL_SHARING_SERVICES["TUMBLR"] = "TUMBLR";
})(SOCIAL_SHARING_SERVICES || (exports.SOCIAL_SHARING_SERVICES = SOCIAL_SHARING_SERVICES = {}));
exports.SOCIAL_SHARING_SERVICES_BI_MAP = (_a = {},
    _a[SOCIAL_SHARING_SERVICES.FACEBOOK] = 'facebook',
    _a[SOCIAL_SHARING_SERVICES.TWITTER] = 'twitter',
    _a[SOCIAL_SHARING_SERVICES.BLOGGER] = 'blogger',
    _a[SOCIAL_SHARING_SERVICES.TUMBLR] = 'tumblr',
    _a);
//# sourceMappingURL=social-sharing-types.js.map